(function () {
    "use strict";
    angular.module("app.common").directive("scorebar", scorebar);

    function scorebar() {
        var directive = {
            controller: [
                "$scope",
                controller,
            ],
            templateUrl: "/app/common/scorebar.directive.html",
            restrict: "EA",
            scope: {
                currentScore: '<', // Current investment score (0-100)
                showTitle: '<'     // Whether to show the title (default: false)
            }
        };

        return directive;

        function controller($scope) {
            // Default values
            $scope.showTitle = $scope.showTitle || false;

            // Investment color palette
            var investmentColors = {
                investmentVeryLow: '#FF4444',    // Very Low - Bright Red
                investmentLow: '#FF8800',        // Low - Orange
                investmentMedium: '#FFD700',     // Medium - Yellow
                investmentGood: '#90EE90',       // Good - Light Green
                investmentPerfect: '#4CAF50'     // Perfect - Dark Green
            };

            // Score ranges with labels (using translate keys)
            $scope.scoreRanges = [
                { range: '0-40', labelKey: 'very_low', color: investmentColors.investmentVeryLow },
                { range: '40-50', labelKey: 'low', color: investmentColors.investmentLow },
                { range: '50-60', labelKey: 'medium', color: investmentColors.investmentMedium },
                { range: '60-70', labelKey: 'good', color: investmentColors.investmentGood },
                { range: '70-100', labelKey: 'perfect', color: investmentColors.investmentPerfect }
            ];

            // Calculate position percentage for current score indicator based on visual zones
            function getVisualPosition(score) {
                // Visual zone mappings: [actual range] -> [visual range]
                if (score <= 40) {
                    // 0-40 -> 0-25%
                    return (score / 40) * 25;
                } else if (score <= 50) {
                    // 40-50 -> 25-45%
                    return 25 + ((score - 40) / 10) * 20;
                } else if (score <= 60) {
                    // 50-60 -> 45-65%
                    return 45 + ((score - 50) / 10) * 20;
                } else if (score <= 70) {
                    // 60-70 -> 65-85%
                    return 65 + ((score - 60) / 10) * 20;
                } else {
                    // 70-100 -> 85-100%
                    return 85 + ((score - 70) / 30) * 15;
                }
            }

            // Calculate indicator position
            $scope.getIndicatorPosition = function () {
                var score = $scope.currentScore || 0;
                var position = Math.min(Math.max(getVisualPosition(score), 0), 100);
                return position + '%';
            };

            // Milestone positions for separator lines
            $scope.milestones = [25, 45, 65, 85];

            // Zone positions for labels (centered in visually balanced zones)
            $scope.getZonePosition = function (index) {
                var zonePositions = [12.5, 35, 55, 75, 92.5];
                return zonePositions[index] + '%';
            };
        }
    }
})();
